module.exports = __webpack_public_path__ + "img/swap-fill.32b32e14.svg";